import { createResourceStore } from "@/lib/resource";
import type { Business } from "./Business";

export interface Warehouse {
  id: string;
  name: string;
  description?: string;
  location_id?: string;
  business_id?: string;
  created_at?: string;
  updated_at?: string;
  location: any;
  business: Business;
}

export const useWharehouse = createResourceStore<Warehouse>("warehouses");
